import {
  baseVendorApiSettingsDefaults,
  defaultHttpAgentSettings,
  defaultRateLimitationSettings,
  defaultSessionSettings,
  defaultVendorApiHttpAdvancedSettings,
} from './base';
import type { SilverPeakApiSettingsDefaults } from './types';

export const silverPeakDefaults: SilverPeakApiSettingsDefaults = {
  ...baseVendorApiSettingsDefaults,
  ...defaultHttpAgentSettings,
  ...defaultRateLimitationSettings,
  ...defaultSessionSettings,
  ...defaultVendorApiHttpAdvancedSettings,
  maxConcurrentRequests: 5,
  keepAlive: false,
  loginType: 'Local',
  defaultSessionTimeoutSec: 30 * 60, // 30 minutes
  broadcastCliMaxRequestAttemptsCount: 10,
  broadcastCliRetryAfterMs: 1000,
};
